export class Signature {
  nom!: string;
  prenom!: string;
  portable!: string;
  email!: string;
  noPortable!: boolean;
  valide1!: boolean;
  valide2!: boolean;
  code!: string;
  telaRappeler!: boolean;
  eMailRecontacte!: string;
  CodeEnvoie!: boolean;

  constructor(
    nom: string,
    prenom: string,
    portable: string,
    email: string,
    noPortable: boolean,
    valide1: boolean,
    valide2: boolean,
    code: string,
    telaRappeler: boolean,
    eMailRecontacte: string,
    CodeEnvoie: boolean,
  ) {
    this.nom = nom;
    this.prenom = prenom;
    this.portable = portable;
    this.email = email;
    this.noPortable = noPortable;
    this.valide1 = valide1;
    this.valide2 = valide2;
    this.code = code;
    this.telaRappeler = telaRappeler;
    this.eMailRecontacte = eMailRecontacte;
    this.CodeEnvoie = CodeEnvoie;
  }
}
